module.exports = __webpack_public_path__ + "img/recent-comments.9672536a.svg";